module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/2/1-e998761af228601fdb61f80882ea4f23.jpg";